import React, { useState, useRef } from "react";
import { useAddNewincMutation, useGetWardsQuery } from "./wardSlice";
const AddInc = () => {
    const [addinc, setAddinc] = useState({ name: "", number: "", inc_ward_id: "" });
    const refClose = useRef(null);

    const {
        data: wards,
        isSuccess,
        isError,
        error
    } = useGetWardsQuery('getWards');
    
    const [addNewinc, { isLoading }] = useAddNewincMutation();

    const handleChange = (e) => setAddinc({ ...addinc, [e.target.name]: e.target.value });

    const handleClick = async (e) => {
        e.preventDefault();
        try {
            await addNewinc({ name: addinc.name, number: addinc.number, inc_ward_id: addinc.inc_ward_id }).unwrap()
            setAddinc({ name: "", number: "", inc_ward_id: "" })
            refClose.current.click()
        }
        catch (e) {
            console.error(e)
        }
    }
    return (
        <>
            <button type="button" className="Add_button bg-left-navabr  text-light  btn btn-secondary" data-bs-toggle="offcanvas" data-bs-target="#depOffCanvas" aria-controls="depOffCanvas"><i className="fa fa-plus" aria-hidden="true"></i> Add New Inc</button>
            <div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="1" id="depOffCanvas" aria-labelledby="depOffCanvas">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvas1Label">Add Inc</h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref={refClose}></button>
                </div>
                <div className="offcanvas-body">
                    <div>
                        <form className="row g-3">
                            <div className="col-md-12 text-left">
                                <label htmlFor="community_name" className="form-label font-weight-bold">
                                    Inc Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="community_name"
                                    name="name"
                                    value={addinc.name}
                                    onChange={handleChange}
                                    placeholder="Name"
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="community_name" className="form-label font-weight-bold">
                                    Number
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="community_name"
                                    name="number"
                                    value={addinc.number}
                                    onChange={handleChange}
                                    placeholder="Number"
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="district_id" className="form-label font-weight-bold">
                                    District Name
                                </label>
                                <select value={addinc.inc_ward_id} onChange={handleChange} className="form-select" id="district_id" name="inc_ward_id" required>
                                    <option value="" defaultValue>
                                        Select Ward
                                    </option>
                                    {wards?.ids?.map((e) => {
                                        return <option value={wards?.entities[e]?.ward_id}>{wards?.entities[e]?.ward_number}</option>
                                    })}
                                </select>
                            </div>

                            <div className="col-md-12">
                                <button type="submit" className="btn btn-ff9b44 btn-block btn-round"
                                    onClick={handleClick}
                                    disabled={!(addinc.name && addinc.number && addinc.inc_ward_id)}
                                >
                                    {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddInc